import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faExpand } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/** Grid card matching WFAGridCard pattern */
export const MockGridCard = ({ title, icon, iconColor, children }: {
  title: string;
  icon: IconDefinition;
  iconColor: string;
  children: React.ReactNode;
}) => (
  <div className="bg-[#181825] rounded-lg border border-white/[0.06] p-4 h-full flex flex-col font-mono">
    <div className="flex items-center gap-2 mb-3 pb-2 border-b border-white/[0.06]">
      <FontAwesomeIcon icon={icon} className={`text-sm ${iconColor}`} />
      <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wide flex-1">{title}</h3>
      <span className="p-1 text-gray-400">
        <FontAwesomeIcon icon={faInfoCircle} className="text-xs" />
      </span>
      <span className="p-1 text-gray-400">
        <FontAwesomeIcon icon={faExpand} className="text-xs" />
      </span>
    </div>
    <div className="flex-1 min-h-0 text-sm">{children}</div>
  </div>
);

/** Metric row matching WFASummaryGridCard pattern */
export const MetricRow = ({ label, value, muted = false }: { label: string; value: string; muted?: boolean }) => (
  <div className="flex justify-between items-baseline">
    <span className={muted ? 'text-gray-500' : 'text-gray-400'}>{label}</span>
    <span className={`font-bold ${muted ? 'font-medium text-gray-300' : 'text-lg text-white'}`}>{value}</span>
  </div>
);

/** Section header matching MetricsGridCard */
export const MetricSection = ({ label }: { label: string }) => (
  <div className="text-[9px] uppercase tracking-wider text-gray-500 mb-1">{label}</div>
);
